import React from 'react';

const PermissionDenied = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div className="text-center bg-white p-8 shadow-lg rounded-lg">
        <h1 style={{ fontWeight: 700, fontSize: '2rem', color: '#222' }}>Permission Denied</h1>
        <p className="mt-4 text-lg text-gray-700">You do not have permission to access this page.</p>
      </div>
    </div>
  );
};

export default PermissionDenied;